import React from 'react';
import Prekindergartengrade_k0 from './prekindergartengrade_k0';
import Prekindergartengrade_k0_subjects from './prekindergartengrade_k0_subjects';
const Prekindergartengrade_k0math = () => {
  return (
    <div>
      <Prekindergartengrade_k0 />
    <Prekindergartengrade_k0_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Mathematics section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Prekindergartengrade_k0math;